import { useEffect, useState } from "react";

/**
 * `prefers-reduced-motion: reduce`, as a value React can branch on.
 *
 * The mobile shell styles inline, and an inline style cannot carry a media
 * query — so the preference is read here instead. SPEC_NAVEGACION_MOVIL asks
 * for the same thing everywhere it appears: no displacement, fades only, 150ms.
 */
export function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(
    () =>
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const on = (e) => setReduced(e.matches);
    // Safari below 14 has only the deprecated listener API.
    if (mq.addEventListener) mq.addEventListener("change", on);
    else mq.addListener(on);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", on);
      else mq.removeListener(on);
    };
  }, []);

  return reduced;
}

export default usePrefersReducedMotion;
